module.exports = __webpack_public_path__ + "img/Labelling_1200x800.8581e199.png";